import { render } from "./DashboardSearch.vue?vue&type=template&id=622d354a"
import script from "./DashboardSearch.vue?vue&type=script&lang=js"
export * from "./DashboardSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__